import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.3105 8.25011L10.8105 12.7501L15.3105 17.2501L14.2499 18.3108L8.68923 12.7501L14.2499 7.18945L15.3105 8.25011Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol